import { atom } from 'jotai';
import { $EnterTraffic } from './traffic';
import { $RootLoaderLoaded } from './load-status';
export const $RootReady = atom((get) => {
    const rootLoaderLoaded = get($RootLoaderLoaded);
    const traffic = get($EnterTraffic);
    return rootLoaderLoaded && traffic.href;
});
